import { MenuItem } from '@mui/material'
import { getSortedCodeSetItems } from './CodeSetFns'
import { tsCodeSetValue, tsLoginConfig } from '../Typescript/API_Response'

export function listFromCodes(
  loginConfig: tsLoginConfig | undefined,
  setName: string,
  loading: boolean,
  defaultValue?: string | number,
) {
  if (loading) {
    return [
      <MenuItem
        value={defaultValue}
        key={'loading'}
      >
        {'Loading...'}
      </MenuItem>,
    ]
  } else {
    return getSortedCodeSetItems(loginConfig, [setName]).map((item: any) => (
      <MenuItem
        value={item.CodeValue}
        key={item.CodeValue}
      >
        {item.CodeDescription}
      </MenuItem>
    ))
  }
}

export function listItemsFromDataObjectArr(
  dataSet: any[] | undefined,
  value: string,
  key: string,
  label: string,
  sortKey: string,
  loading: boolean,
  defaultValue?: string | number,
) {
  if (loading) {
    return [
      <MenuItem
        value={defaultValue}
        key={'loading'}
      >
        {'Loading...'}
      </MenuItem>,
    ]
  } else if (dataSet) {
    return dataSet
      .sort((a, b) => {
        if (typeof a[sortKey] === 'string') {
          return a[sortKey].localeCompare(b[sortKey])
        } else {
          return a[sortKey] - b[sortKey]
        }
      })
      .map((item) => (
        <MenuItem
          value={item[value]}
          key={item[key]}
        >
          {item[label]}
        </MenuItem>
      ))
  } else {
    return []
  }
}

export function listFromKV(
  data: tsCodeSetValue[],
  loading: boolean,
  defaultValue?: string | number,
) {
  return listItemsFromDataObjectArr(
    data,
    'CodeValue',
    'CodeValue',
    'CodeDescription',
    'reqSortOrder',
    loading,
    defaultValue,
  )
}

export function autoOptionsFromData(
  dataSet: any[] | undefined,
  value: string,
  label: string,
) {
  return dataSet ?
      dataSet
        .filter((item) => item?.[value]) //error handling for BBS-12
        .map((item) => {
          return { value: item[value], label: item?.[label] ?? '<missing>' } //error handling for BBS-12
        })
    : []
}

export function autoOptionsFromCodeValues(
  dataSet: tsCodeSetValue[] | undefined,
) {
  return autoOptionsFromData(dataSet, 'CodeValue', 'CodeDescription')
}
